import { Tag, type TagVariantType } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import {
  USER_PERMISSION_LEVELS,
  USER_PERMISSIONS_CATEGORIES,
} from "common/constants";
import { typedObjectEntries } from "common/helpers/utils";
import useMemberPermissionsState from "common/hooks/useMemberPermissionsState";
import type { UserPermissions, UserRole } from "common/types";

interface MemberPermissionsTagProps {
  role: UserRole;
  permissions: UserPermissions;
}

const userRoles: Record<
  UserRole,
  {
    label: string;
    tagVariant: TagVariantType;
  }
> = {
  owner: {
    label: "Owner",
    tagVariant: "secondary",
  },
  admin: {
    label: "Admin",
    tagVariant: "danger",
  },
  member: {
    label: "Member",
    tagVariant: "tertiary",
  },
};

export default function MemberPermissionsTag({
  role,
  permissions,
}: MemberPermissionsTagProps) {
  const { memberPermissionsState } = useMemberPermissionsState(permissions);

  const { label, tagVariant } = userRoles[role];

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Tag variant={tagVariant}>{label}</Tag>
      </TooltipTrigger>
      <TooltipContent className="whitespace-pre text-left">
        {typedObjectEntries(memberPermissionsState).map(
          ([key, value]) =>
            `${USER_PERMISSIONS_CATEGORIES[key].label}: ${USER_PERMISSION_LEVELS[value].label}\n`,
        )}
      </TooltipContent>
    </Tooltip>
  );
}
